import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body {
    color: var(--gray-900) !important;
    overflow-y: auto !important;
  }

  ._font-14 {
    font-size: 0.875rem;
  }

  ._font-weight-semibold {
    font-weight: 600;
  }

  ._font-weight-extrabold {
    font-weight: 800;
  }

  ._font-weight-black {
    font-weight: 900;
  }

  [data-type="mention"], [data-action="open-profile"] {
    color: var(--blue) !important;
    text-decoration: none !important;

    &:hover {
      text-decoration: underline !important;
    }
  }

  .tour-app-consumer{
    background-color: var(--gray-400) !important;
    border-radius: var(--border-radius-lg) !important;

    .introjs-skipbutton{
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
    }

    .introjs-tooltiptext{
      padding: .75rem !important;
    }

    .introjs-arrow.top{
      border-bottom-color: var(--gray-400) !important;
    }

    .introjs-arrow.bottom{
      border-top-color: var(--gray-400) !important;
    }

    .introjs-arrow.left{
      border-right-color:var(--gray-400) !important;
    }

    .introjs-arrow.right{
      border-left-color:var(--gray-400) !important;
    }
  }

`

export default GlobalStyle
